import React from 'react'
import Head from 'next/head'
import Pitch from '@src/components/DisposalPage/Pitch'
import FeatureList from '@src/components/DisposalPage/FeatureList'
import Approach from '@src/components/DisposalPage/Approach'
import FAQ from '@src/components/DisposalPage/FAQ'
import SustainabilityDashboardPromo from '@src/components/DisposalPage/SustainabilityDashboardPromo'
import SchemaMarkup from '@src/components/SchemaMarkup'
import RelatedServices from '@src/components/RelatedServices'
import Clients from '@src/pages/LandingPage/Clients'
import Testimonials from '@src/pages/LandingPage/Testimonials'
import junkTestimonials from '@src/constants/junkTestimonials'
import TrustBox from '@src/pages/common/components/TrustBox'
import TrustedByClients from '@src/components/DisposalPage/TrustedByClients'
import pageClasses from '@src/styles/junk-removal-page.module.css'
// eslint-disable-next-line import/extensions
import yard from '../../json/yard-debris-removal-data.json'

const yardServiceData = {
  name: 'Yard Waste and Debris Removal',
  description:
    'Eco-friendly yard waste removal for homes and businesses nationwide. Dimension clears branches, leaves, brush, dirt, sod, and shed teardowns, priced by the cubic yard, and routes green waste to composting.',
  serviceType: 'Yard Waste Removal',
  url: 'https://getdimension.com/yard-debris-removal',
  provider: {
    name: 'Dimension',
    url: 'https://getdimension.com',
    address: {
      streetAddress: '2261 Market Street, #4061',
      addressLocality: 'San Francisco',
      addressRegion: 'CA',
      postalCode: '94114',
      addressCountry: 'US',
    },
    telephone: '+1 (415) 340-7182',
  },
  offers: [
    { name: 'Branch and Tree Limb Removal' },
    { name: 'Leaf and Grass Clipping Removal' },
    { name: 'Dirt, Sod, and Turf Removal' },
    { name: 'Shed, Fence, and Deck Teardown' },
    { name: 'Green Waste Composting and Mulching' },
  ],
}

const yardFAQData = {
  questions: yard.FAQContent.contentList.map((faq) => ({
    question: faq.heading.replace(/<[^>]*>/g, ''),
    answer: faq.textList.join(' '),
  })),
}

function YardDebrisRemoval() {
  return (
    <>
      <Head>
        <title>Yard Waste &amp; Debris Removal Services | Dimension</title>
        <meta
          name="description"
          content="Eco-friendly yard waste removal nationwide. Dimension clears branches, leaves, brush, and shed teardowns, priced by the cubic yard from around $79, and composts green waste."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://getdimension.com/yard-debris-removal" />
        <SchemaMarkup type="WebSite" />
        <SchemaMarkup type="Service" data={yardServiceData} />
        <SchemaMarkup type="FAQPage" data={yardFAQData} />
        <SchemaMarkup type="LocalBusiness" />
      </Head>
      <div className={pageClasses.root}>
        <Pitch
          variant="hazardous-waste"
          heroImage="junk"
          heading={yard.pitch.heading}
          material={yard.pitch.material}
          pitchText={yard.pitch.pitchText}
          ctaLink={yard.pitch.ctaLink}
          ctaText={yard.pitch.ctaText}
          belowCta={<TrustBox isMobile isDark={false} />}
          belowPitch={<TrustedByClients />}
        />
        <Testimonials testimonials={junkTestimonials} />
        <Clients />
        <FeatureList {...yard.solutions} />
        <SustainabilityDashboardPromo />
        <FeatureList {...yard.benefits} />
        <Approach {...yard.approach} />
        <FAQ {...yard.FAQContent} />
        <RelatedServices
          services={[
            {
              label: 'Junk Removal',
              href: '/junk-removal',
              description:
                'Full-service junk hauling and whole-home or office cleanouts, priced by volume.',
            },
            {
              label: 'Furniture Removal',
              href: '/furniture-removal',
              description:
                'Convenient removal of sofas, chairs, desks, and bulky furniture, with donation and recycling first.',
            },
            {
              label: 'Dumpster Rental',
              href: '/dumpster-rental',
              description:
                'Roll-off dumpster rentals for larger cleanups, renovations, and ongoing projects.',
            },
            {
              label: 'Appliance Removal',
              href: '/appliance-removal',
              description:
                'Pickup and metal recycling of refrigerators, washers, ovens, and other appliances.',
            },
          ]}
        />
      </div>
    </>
  )
}

export default YardDebrisRemoval
